import { useCallback } from 'react';
import { getSelectedAccountInfo } from '@ibk/shared-auth';
import { useLazyValidateIntegrationQuery } from '@ibk/shared-config';
import { CONTABIL_COMPANY_LINK_ROUTE } from '../contabilCompanyLink.constants';
import { deriveOfficeIntegrationState } from '../officeIntegrationState';
import { hasCompletedContabilCompanyLink, hasSkippedContabilCompanyLink, shouldShowContabilCompanyLink, } from './contabilCompanyLinkFlow';
import { usePlatformAccountantIntegrationSgdAccess } from './usePlatformAccountantIntegrationSgdEnabled';
export { shouldShowContabilCompanyLink } from './contabilCompanyLinkFlow';
export function useContabilCompanyLinkRedirect() {
    const [fetchValidateIntegration] = useLazyValidateIntegrationQuery();
    const { refreshAndCheckEnabled } = usePlatformAccountantIntegrationSgdAccess();
    const resolveDestinationByIntegration = useCallback(async () => {
        const partyId = getSelectedAccountInfo()?.partyId ?? '';
        if (!partyId) {
            return '/home';
        }
        try {
            const response = await fetchValidateIntegration({ partyId }).unwrap();
            const state = deriveOfficeIntegrationState(response, false);
            return shouldShowContabilCompanyLink(state !== 'linked') ? CONTABIL_COMPANY_LINK_ROUTE : '/home';
        }
        catch {
            return shouldShowContabilCompanyLink(true) ? CONTABIL_COMPANY_LINK_ROUTE : '/home';
        }
    }, [fetchValidateIntegration]);
    const resolveDestination = useCallback(async (_organizationId) => {
        const isIntegrationFlagEnabled = await refreshAndCheckEnabled();
        if (!isIntegrationFlagEnabled) {
            return '/home';
        }
        if (hasSkippedContabilCompanyLink() || hasCompletedContabilCompanyLink()) {
            return '/home';
        }
        return resolveDestinationByIntegration();
    }, [refreshAndCheckEnabled, resolveDestinationByIntegration]);
    return { resolveDestination };
}
